import React, { useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';

const LegacyRedirect = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    
    useEffect(() => {
        const handleRedirect = async () => {
            const oldId = searchParams.get('uId');
            const pathName = location.pathname.toLowerCase();

            // Tip eşleştirmeleri
            const typeMapping = {
                'paperdetail': ["Akademik Makale", "Popüler Dergi Yazısı"],
                'journaldetail': ["Dergi"],
                'bookdetail': ["Akademik Kitap", "Popüler Kitap", "Konferans ve Armağan"],
                'bookpartdetail': ["Akademik Kitap Bölümü", "Popüler Kitap Bölümü", "Konferans ve Armağan Yazısı"],
                'documentingredient': ["Akademik Dergi Sayısı", "Popüler Dergi Sayısı"]
            };

            // URL'den hangi tip olduğunu bul (bookdetail, paperdetail vb.)
            const key = Object.keys(typeMapping).find(k => pathName.includes(k));
            const typesToTry = typeMapping[key] || [];

            if (!oldId || typesToTry.length === 0) {
                navigate('/404', { replace: true });
                return;
            }

            // API isteklerini sırayla dene
            for (const typeName of typesToTry) {
                try {
                    const apiUrl = `https://idealonline.com.tr/service/idealonline/v1/publications/search/publicationOldIdDetailDTO/${oldId}/${encodeURIComponent(typeName)}`;
                    
                    const response = await fetch(apiUrl);
                    const result = await response.json();

                    if (result.status === "OK" && result.data && result.data.id) {
                        // Bulundu! Yeni sayfaya yönlendir
                        navigate(`/publication-details/${result.data.id}`, { replace: true });
                        return;
                    }
                } catch (error) {
                    console.error(`${typeName} denemesinde hata:`, error);
                }
            }

            // Hiçbiri sonuç vermediyse
            navigate('/404', { replace: true });
        };

        handleRedirect();
    }, [location, navigate, searchParams]);

    return (
        <div className='text-center justify-content-center align-items-center text-primary'>
            <p>Eski sistemden yönlendiriliyorsunuz, lütfen bekleyin...</p>
            {/* Buraya bir Spinner/Loading ikonu koyabilirsiniz */}
        </div>
    );
};

export default LegacyRedirect;